import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive } from "vue"
import _imports_0 from '@/assets/images/logo-banner.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "logo-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-logo",
    src: _imports_0
  })
], -1)
const _hoisted_2 = { class: "header_nav" }
const _hoisted_3 = { class: "userinfo" }
const _hoisted_4 = { class: "el-dropdown-link" }
const _hoisted_5 = { class: "userinfo task-box" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-lingdang" }, null, -1)
const _hoisted_7 = { class: "view-box" }

import { ArrowDown } from '@element-plus/icons-vue';
	import { fullscreenLoading, formLoading } from '@/utils/loading';
	import HeaderMenu from '@/components/menu/HeaderMenu.vue';
	import LeftMenu from '@/components/menu/LeftMenu.vue';
	import PageCard from '@/components/menu/PageCard.vue';
	import { ElMessageBox } from 'element-plus';
	import { logout } from '@/api/auth';
	import {updateUserPassword} from '@/api/user'
	import { cacheFlush } from '@/api/basic';
	import { removeLocalStorage } from '@/utils/localStorage';
	import { useStore } from 'vuex';
	import router from '@/router/index'
	import { computed, ref, reactive } from 'vue';
	import type { FormInstance } from 'element-plus';
	import { messageSuccess } from '@/utils/message';

	//用户信息
	
export default /*#__PURE__*/_defineComponent({
  __name: 'masterLayout',
  setup(__props) {

	const store = useStore();
	let userinfo = computed(() => store.state.user.userinfo);
	let cachedViews = computed(() => store.state.menu.cachedViews);

	//右上角下拉菜单操作指令
	const userCommand = (command: string) => {
		if (command == 'logout') {
			//退出
			ElMessageBox.confirm('确认退出当前账户吗?将会清除登录信息', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					const Loading = fullscreenLoading();
					logout()
						.then((res:any) => {
							Loading.close();
							if(res.code == 200) {
								removeLocalStorage('Authorization')
								store.commit('user/setUserInfo',[]);
								store.commit('menu/setNavList',[]);
								// //异步获取系统配置
								store.commit('config/getConfiglist',[]);
								// //异步获取字典配置
								store.commit('config/getDictList',[]);
								messageSuccess(res.msg);
								router.push('/admin/login')
							}
						})
						.catch(() => {
							// catch error
							Loading.close();
						});
				})
				.catch(() => {
					// catch error
				});
		} else if (command == 'updatePassword') {
			isVisible.value = true;
		} else if (command == 'cacheFlush') {
			const Loading = fullscreenLoading();
			cacheFlush()
				.then((res: any) => {
					Loading.close();
					messageSuccess(res.msg);
				})
				.catch(() => {
					Loading.close();
				});
		}
	};

	const formRef = ref<FormInstance>();
	//修改密码FORM
	let form = reactive({
		oldPsw: '', //原始密码
		newPsw: '', //新密码
		rePsw: '', //确认密码
	});
	const isVisible = ref(false);
	//关闭修改密码
	const handleClose = () => {
		isVisible.value = false;
	};
	//保存
	const submitForm = (formEl: FormInstance | undefined) => {
		if (!formEl) return;
		formEl.validate((valid) => {
			if (valid) {
				const Loading = formLoading();
				updateUserPassword(form)
					.then((res: any) => {
						Loading.close();
						messageSuccess(res.msg);
						handleClose();
					})
					.catch(() => {
						Loading.close();
					});
			}
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(HeaderMenu),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_dropdown, { onCommand: userCommand }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "updatePassword" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 修改密码 ")
                          ]),
                          _: 1
                        }),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_el_dropdown_item, { command: "cacheFlush" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 清除缓存 ")
                            ]),
                            _: 1
                          })
                        ])), [
                          [_directive_permission, 2]
                        ]),
                        _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 退出登录 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, [
                      _createTextVNode(" 欢迎您 " + _toDisplayString(_unref(userinfo).au_nickname) + " ", 1),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowDown))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_badge, {
                  class: "test",
                  max: 99
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_el_dialog, {
              modelValue: isVisible.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isVisible).value = $event)),
              title: "修改密码",
              width: "400px",
              "before-close": handleClose,
              "destroy-on-close": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  model: _unref(form),
                  ref_key: "formRef",
                  ref: formRef,
                  "label-width": "80px",
                  "require-asterisk-position": "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "原始密码",
                      prop: "oldPsw",
                      rules: [{ required: true, trigger: 'blur', message: '密码必须填写!' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(form).oldPsw,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).oldPsw) = $event)),
                          type: "password",
                          clearable: "",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "新密码",
                      prop: "newPsw",
                      rules: [{ required: true, trigger: 'blur', message: '密码必须填写!' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(form).newPsw,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).newPsw) = $event)),
                          type: "password",
                          clearable: "",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "确认密码",
                      prop: "rePsw",
                      rules: [{ required: true, trigger: 'blur', message: '密码必须填写!' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(form).rePsw,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).rePsw) = $event)),
                          type: "password",
                          clearable: "",
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(formRef.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("保存")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, null, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { width: "auto" }, {
            default: _withCtx(() => [
              _createVNode(LeftMenu)
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(PageCard),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component, route }) => [
                        (_openBlock(), _createBlock(_KeepAlive, null, [
                          (route.meta.keepAlive)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                                key: route.path
                              }))
                            : _createCommentVNode("", true)
                        ], 1024)),
                        (!route.meta.keepAlive)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                              key: route.path
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})